import {IPromise} from "angular";
import {HttpResponseServiceName} from "../../utils/names/serviceNames";
import {Page} from "../../utils/models/Page";
import {ArchivedLoanLog} from "../model/ArchivedLoanLog";
import {getAbsoluteUrl} from "../../utils/urlUtill";
import {Borrower} from "../../customers/model/Borrower";
import {ArchivedBorrower} from "../../customers/model/ArchivedBorrower";
import {HttpResponseService} from "../../utils/HttpResponseService";


export class LoanArchiveService {

    static instance = [
        HttpResponseServiceName,
        LoanArchiveService
    ]

    constructor(private httpResponseService: HttpResponseService) {
    }

    fetchLogs = (borrower: Borrower, pageNumber: number, pageSize: number): IPromise<Page<ArchivedLoanLog>> => {
        return this.httpResponseService.executeHttp<Page<ArchivedLoanLog>>('archived loans page',
            {
                method: 'GET',
                url: getAbsoluteUrl(`api/customer/${borrower.id}/loan-archive`),
                params: {
                    pageNumber: pageNumber,
                    pageSize: pageSize
                }
            }
        );
    }

    fetchLogDetails = (log: ArchivedLoanLog): IPromise<ArchivedBorrower> => {
        return this.httpResponseService.executeHttp('archived loan details',
            {
                method: 'GET',
                url: getAbsoluteUrl(`api/customer/loan-archive/${log.id}`)
            }
        );
    }

}